import { useParams } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';

/**
 * Returns the wedding slug whether accessed via /w/:slug path or subdomain.
 * Also provides a helper to build wedding-relative paths.
 */
export default function useWeddingSlug() {
  const params = useParams();
  const { slug: contextSlug, subdomain } = useContent();
  const slug = params.slug || contextSlug;

  /**
   * Build a path relative to the wedding root.
   * On subdomain: weddingPath('/rsvp') => '/rsvp'
   * On main domain: weddingPath('/rsvp') => '/w/my-slug/rsvp'
   */
  const weddingPath = (path = '') => {
    if (subdomain) return path || '/';
    return `/w/${slug}${path}`;
  };

  return { slug, subdomain, weddingPath };
}
